import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-aepsdevice-config-model',
  templateUrl: './aepsdevice-config-model.component.html',
  styleUrls: ['./aepsdevice-config-model.component.scss']
})
export class AepsdeviceConfigModelComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AepsdeviceConfigModelComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
